import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from './apiClient';

const upload = async ({ file, orgId, employeeId, documentTypeId }) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post(API_ENDPOINTS.documents.upload, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const documentService = { upload };
